import WeChatScanner from './WeChatScanner'

export default WeChatScanner